import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  
  root: {
    width: "100%",
    padding: theme.spacing(0, 2),
    marginTop: theme.spacing(2),
  },
  chipSection: {
    justifyContent: "space-between",
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
    [theme.breakpoints.down("sm")]: {
      display: "inline-grid",
      justifyContent: "normal",
    },
  },
  searchInput: {
    width: "100%",
  },
  searchButton: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginBottom: theme.spacing(1),
    },
  },

  sectionDivider: {
    backgroundColor: theme.palette.common.black,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    marginTop: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      marginRight: theme.spacing(4)
    }
  },
  contentWrapper: {
    marginTop: theme.spacing(4),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    overflow: "visible",
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(1),
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
  },
  contentInner: {
    width: "100%",
  },


  paginationWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    paddingRight: theme.spacing(1),
    "& .MuiPagination-ul": {
      justifyContent: "flex-end",
    },
  },

 table: {
    width: "100%",
    borderCollapse: "collapse",
    border: `1px solid ${theme.palette.grey[400]}`,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    tableLayout: "fixed",
  },
  headerRow: {
    backgroundColor: "#e5eaee",
    borderBottom: "1px solid #c7cfd6",
  },
  headerCell: {
    fontWeight: 600,
    fontSize: 13,
    padding: theme.spacing(1.5, 2),
    borderRight: `1px solid ${theme.palette.grey[400]}`,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      fontSize: 11,
      padding: theme.spacing(1, 0.5),
    },
  },
  bodyRow: {
    height: 48,
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    [theme.breakpoints.down("sm")]: {
      height: 40,
    },
  },
  bodyCell: {
    fontSize: 13,
    padding: theme.spacing(1, 2),
    borderRight: `1px solid ${theme.palette.grey[300]}`,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      fontSize: 11,
      padding: theme.spacing(0.5, 0.5),
    },
  },
  
  sendInvitesWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  noResults: {
    marginTop: 50,
    textAlign: "center",
    width: "98%",
    "& .no-results-text": {
      border: `1px solid ${"#c62828"}`,
      padding: "8px 92px 8px 92px",
      backgroundColor: "#fff",
      fontSize: "14pt",
      fontStyle: "italic",
      fontWeight: "bold",
      color: "#d32f2f",
      opacity: 0.7,
      borderRadius: 3,
      boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
    },
  },
}));
